<template>
    <span class="notification-counter" v-if="notifications > 0">{{ notifications > 99 ? '99+' : notifications }}</span>
</template>

<script>

export default {
    name: "NotificationsCounter",
    props: {
        notifications: Number
    }
}
</script>

<style lang="scss" scoped>
.notification-counter {
    font-size: 0.7rem;
    line-height: 1;
    font-weight: bold;
    min-width: 18px;
    text-align: center;
    background: var(--primary);
    border-radius: 5px;
    color: white;
    padding: 2px 7px;
}
</style>